// src/chains/bitrock.js - Keep using direct contract calls for now
import { createChainConfig } from './chainConfig';

export const bitrockConfig = createChainConfig({
  key: 'bitrock', 
  chainId: 7171,
  name: 'Bitrock Mainnet',
  rpcUrl: 'https://connect.bit-rock.io',
  explorerUrl: 'https://explorer.bit-rock.io',
  
  // Native token information
  nativeTokenSymbol: 'BROCK',
  nativeTokenName: 'Bitrock',
  nativeTokenIcon: 'https://i.imgur.com/7mt3nT9.png',
  nativeTokenDecimals: 18,
  
  // Related token addresses
  wrappedNativeToken: '0x413f0E3A440abA7A15137F4278121450416882d5', // WBROCK on Bitrock
  
  // Price and API endpoints
  coingeckoAPI: 'https://api.coingecko.com/api/v3/simple/price?ids=bitrock&vs_currencies=usd&include_24hr_change=true',
  coingeckoId: 'bitrock',
  geckoTerminalId: 'bitrock',
  tokenListUrl: 'https://raw.githubusercontent.com/BitrockChain/rockswap-tokenlist/main/dir.json',
  
  // BitDogSwap aggregator address - continue using direct contract calls
  aggregatorAddress: '0xc87990efC832e0d93827f5Fb6177B04CfDf04D5c',
  
  // Transaction support
  supportsEIP1559: false,

  txHistoryApi: 'https://api.routescan.io/v2/network/mainnet/evm/7171/address/{address}/transactions'
});